/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ListingAvailableOptions } from '../models/ListingAvailableOptions';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ListingAvailableOptionsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Returns filters and sortings to display for a given listing context
     * Retrieves a ListingAvailableOptions resource.
     * @param listingType
     * @param listingId Slug of the listing entity
     * @returns ListingAvailableOptions ListingAvailableOptions resource
     * @throws ApiError
     */
    public accommodationListingAvailableOptions(
        listingType: 'city' | 'country' | 'voivodeship' | 'poi' | 'campaign' | 'region',
        listingId: string,
    ): CancelablePromise<ListingAvailableOptions> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/accommodations/listing/available-options',
            query: {
                listingType: listingType,
                listingId: listingId,
            },
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
}
